// extracted by mini-css-extract-plugin
export default {"track":"ScrollbarBookmarks_track__6YInZ","thumb":"ScrollbarBookmarks_thumb__lmjmq","bookmark":"ScrollbarBookmarks_bookmark__Nlglv","tooltip":"ScrollbarBookmarks_tooltip__g4Zdy"};